// extracted by mini-css-extract-plugin
export default {"price":"price_price__yJHF9"};